import { Link } from "react-router-dom";
import { heroAnchors, siteInfo } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full flex flex-col">
      <div className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20investigative%20scene%20of%20faceless%20digital%20crowd%20silhouettes%20in%20deep%20charcoal%20with%20crimson%20glowing%20screen%20light%2C%20moody%20low%20key%20editorial%20photography%2C%20grainy%20texture%2C%20anonymous%20figures%2C%20cinematic%20high%20contrast%2C%20warm%20dark%20undertones&width=1800&height=1000&seq=wbh-hero-01&orientation=landscape"
            alt="夜色中匿名账号组成的网络人群剪影，象征网络暴力中的施暴者与围观者"
            title="网暴黑料调查 · 黑料显微镜"
            className="w-full h-full object-cover object-top animate-slowDrift"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-14 md:pt-32 md:pb-20">
          <div className="max-w-content mx-auto w-full">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-xs md:text-sm text-background-100 animate-fadeIn">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              独立调查 · 只分析公开可核验的信息
            </p>

            <h1 className="mt-6 md:mt-8 font-heading font-black text-background-50 leading-tight animate-riseIn text-3xl md:text-5xl lg:text-6xl max-w-4xl">
              <span className="block text-sm md:text-base font-medium tracking-[0.35em] text-accent-300 mb-3 md:mb-4">
                {siteInfo.name}
              </span>
              起底网暴黑料背后的
              <span className="text-accent-400">施暴者、键盘侠与水军组织</span>
            </h1>

            <p className="mt-5 md:mt-6 text-sm md:text-lg leading-relaxed text-background-200 max-w-2xl animate-fadeIn">
              我们不做情绪化的围观，只做一件事：把每一起网暴黑料拆开来看——谁在发第一条、谁在带节奏、谁在收钱刷屏，以及那些沉默的推手究竟想得到什么。
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
              <Link
                to="/cases"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-colors bg-primary-500 text-background-50 hover:bg-primary-600"
              >
                <i className="ri-archive-2-line" aria-hidden="true"></i>
                浏览全部调查档案
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-colors bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20"
              >
                <i className="ri-book-open-line" aria-hidden="true"></i>
                了解我们的调查方式
              </Link>
            </div>
          </div>
        </div>
      </div>

      <nav aria-label="页内导航" className="w-full bg-background-50 border-b border-background-200">
        <div className="max-w-content mx-auto px-4 md:px-6 py-3 md:py-4">
          <ul className="flex flex-wrap items-center gap-x-2 gap-y-2 md:gap-x-3">
            <li className="hidden md:flex items-center gap-2 pr-3 mr-1 border-r border-background-200">
              <i className="ri-list-check-2 text-primary-600" aria-hidden="true"></i>
              <span className="text-xs font-label tracking-widest text-foreground-500">本站导航</span>
            </li>
            {heroAnchors.map((anchor) => (
              <li key={anchor.href}>
                <a
                  href={anchor.href}
                  className="inline-block px-3.5 py-1.5 rounded-full text-xs md:text-sm text-foreground-700 bg-background-100 hover:bg-secondary-100 hover:text-secondary-900 whitespace-nowrap transition-colors cursor-pointer"
                >
                  {anchor.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </section>
  );
}